import { Component, Input, OnChanges, ViewChild } from '@angular/core';

import { SecondMs } from 'rev-shared/date/Time.Constant';

import { IProducerBgImage } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

import { IProducerOptions } from '../../Contract';
import { ProducerService } from '../../Producer.Service';
import { VideoPreviewPlayerComponent } from './VideoPreviewPlayer.Component';

import styles from './VideoPreview.module.less';

@Component({
	selector: 'preview-view',
	templateUrl: './PreviewView.Component.html',
	standalone: false
})
export class PreviewViewComponent implements OnChanges {
	@Input() public isProducer: boolean;
	@Input() public producerOptions: IProducerOptions;
	@Input() public bgImages: IProducerBgImage[];

	public readonly styles = styles;
	public helperText = 'Event_Producer_PreviewWindow';
	public sendLiveDisabled: boolean;

	@ViewChild(VideoPreviewPlayerComponent)
	public playerCmp: VideoPreviewPlayerComponent;

	constructor(
		private readonly ProducerService: ProducerService
	) {}

	public ngOnChanges(): void {
		if (this.producerOptions.onStageLayout.videos?.length > 0) {
			this.helperText = '';
		}
	}

	public sendVideoLive(): void {
		if(this.sendLiveDisabled) {
			return;
		}
		this.sendLiveDisabled = true;
		setTimeout(() => this.sendLiveDisabled = false, 2 * SecondMs);

		this.ProducerService.sendPreviewLive(() => this.playerCmp.getScreenshot())
			.catch(e => {
				console.error('sendVideoLive: ', e);
			});
	}
}
